import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {gettextCatalog} from "angular-gettext";
import {MeldingTilBruker, Varighet} from "felles/tjenester/MeldingTilBruker";
import {Filer} from "felles/tjenester/Filer";
import {Logger} from "../../../felles/infrastruktur/Logging";
import {Dialog} from "../Dialog";
import {ILogService} from "angular";
import {FilValidering} from "web/tjenester/FilValidering";

export class ArkivWebRessurs {

    static regNavn = "ArkivWebRessurs";

    static forInjisering() {
        return [
            regNavn.ng.$log,
            MeldingTilBruker.regNavn,
            Dialog.regNavn,
            Logger.regNavn,
            regNavn.ngFileUpload.Upload,
            Filer.regNavn,
            FilValidering.regNavn,
            regNavn.gettext.gettextCatalog,
            ArkivWebRessurs
        ]
    }

    constructor(public $log: ILogService,
                public meldingTilBruker: MeldingTilBruker,
                private dialog: Dialog,
                public logger: Logger,
                public ngFileUpload: angular.angularFileUpload.IUploadService,
                public filer: Filer,
                private filValidering: FilValidering,
                public gettextCatalog: gettextCatalog) {
    }

    dokumentopplastinger = {};

    //offentlige metoder

    registrerFiler(mappe: l.ArkivMappenodeModell, filer: File[], vedOk: (nyttDokument: l.ArkivFilnodeModell) => any) {
        return this.filValidering.validerFilerFørOpplastingOgVisDialogHvisFeilet(filer).then(filerErGyldige => {
            // Hvis vi viser dialog etter validering fortsetter vi ikke med opplasting av noen filer
            if(!filerErGyldige) return;

            const kandidater: { oppdaterte: { fil: File; eksisterende: l.ArkivFilnodeModell; }[]; nye: { fil: File; eksisterende: l.ArkivFilnodeModell; }[] } = <any>_(filer)
              .map(fil => ({
                  fil: fil,
                  eksisterende: _(mappe.barn).filter(node => !node.erMappe).find((eksiterende: l.ArkivFilnodeModell) => eksiterende.dokument.filnavn === fil.name)
              }))
              .groupBy(nyOgEksisterende => nyOgEksisterende.eksisterende ? 'oppdaterte' : 'nye')
              .value();

            if (!_.isEmpty(kandidater.oppdaterte)) {
                const filnavn = _(kandidater.oppdaterte).map(oppdatert => `<li>${oppdatert.eksisterende.dokument.filnavn}</li>`).join('');

                ///dialoginnhold for dialog ved opplasting av filsom allerede finnes
                const dialogInnhold = this.gettextCatalog.getString('Følgende dokumenter eksisterer allerede, vil du registrere disse som nye versjoner?');

                this.dialog.confirm(
                  ///dialogtittel for dialog ved opplasting av filsom allerede finnes
                  this.gettextCatalog.getString('Dokumentregistrering'),
                  `</div><p>${dialogInnhold}</p> <ul class="e2e-fileksisterer">${filnavn}</ul>`,
                  ///ok-knapp i dialog ved opplasting av filsom allerede finnes
                  this.gettextCatalog.getString('Registrer'),
                  ///avbryt-knapp i dialog ved opplasting av filsom allerede finnes
                  this.gettextCatalog.getString('Avbryt'))
                  .then(() => {
                      _(kandidater.oppdaterte).each(oppdatert => {
                          this.opprettNyDokumentVersjon(mappe.id, oppdatert.eksisterende.id, oppdatert.fil, vedOk)
                      });
                  });
            }

            if (!_.isEmpty(kandidater.nye)) {
                this.opprettDokumenter(mappe.id, _(kandidater.nye).map(ny => ny.fil).value(), vedOk);
            }
        });
    }


    /**
     * Laster opp angitte filer under angitt mappe.
     * Filer vil bli lastet opp sekvensielt. Dette da serversiden ikke takler
     * parallelle kall til arkiv/... (pga hibernate List oppførsel)
     */
    opprettDokumenter(mappeId: string, filer: File[], vedOk: (nyttDokument: l.ArkivFilnodeModell) => void) {
        var opplastinger = _(filer).map(fil => ArkivFilopplasting.opprettDokument(fil, mappeId, vedOk, this)).value();

        var lastOppSekvensielt = () => {
            if (_.isEmpty(opplastinger)) return;
            let opplasting = opplastinger.pop();
            if (!opplasting.avbrutt) {
                opplasting
                .startOpplasting()
                .jobb.finally(() => lastOppSekvensielt());
            } else {
                // fortsett på listen
                lastOppSekvensielt()
            }

        };

        lastOppSekvensielt();
    }

    /**
     * Laster opp angitte fil som ny versjon under angitt dokument.
     * Filer vil bli lastet opp sekvensielt. Dette da serversiden ikke takler
     * parallelle kall til arkiv/... (pga hibernate List oppførsel)
     */
    opprettNyDokumentVersjon(mappeId: string, arkivFilnodeId: string, fil: File, vedOk: (nyttDokument: l.ArkivFilnodeModell) => void) {
        var opplasting = ArkivFilopplasting.opprettDokumentVersjon(fil, mappeId, arkivFilnodeId, vedOk, this);

        opplasting
            .startOpplasting()
            .jobb.finally(() => {
            console.log("lastet opp..")
        });
    }

    /**
     * Laster opp angitte zipfil og importerer innholdet til angitt rotmappe.
     */
    importerArkivFraZip(rotmappeId: string, fil: File, vedOk: (importresultat: l.ImportresultatModell) => void): ArkivFilopplasting<l.ImportresultatModell> {
        var opplasting = ArkivFilopplasting.importerArkivFraZip(fil, rotmappeId, vedOk, this);
        return opplasting.startOpplasting();
    }

    finnOpplastinger(mappeId: string): ArkivFilopplasting<any>[] {
        return this.dokumentopplastinger[mappeId];
    }

    //hjelpemetoder

    registrerOpplasting(opplasting: ArkivFilopplasting<any>) {
        if (!this.dokumentopplastinger[opplasting.mappeId]) this.dokumentopplastinger[opplasting.mappeId] = [];
        this.dokumentopplastinger[opplasting.mappeId].push(opplasting);
    }

    fjernOpplasting(opplasting: ArkivFilopplasting<any>) {
        if (!this.dokumentopplastinger[opplasting.mappeId]) return;
        _.remove(this.dokumentopplastinger[opplasting.mappeId], o => o === opplasting);
    }

    //statiske hjelpemetoder

}

export class ArkivFilopplasting<RETUR> {
    jobb: angular.angularFileUpload.IUploadPromise<RETUR>;
    avbrutt = false;
    progresjon = 0;
    formatikon = "lederplan-ikon-pdf";
    formatnavn = "pdf";
    viserDetaljer = false;
    mimetype: string;

    constructor(public fil: File, public mappeId: string, private url: string, private vedOk: (nyttDokument: RETUR) => void, private arkivWebRessurs: ArkivWebRessurs) {
        arkivWebRessurs.registrerOpplasting(this);

        this.mimetype = fil.type || arkivWebRessurs.filer.finnMimetypeBasertPåFilendelse(fil);
        // Se #282
        if (_.isEmpty(this.mimetype)) {
            this.avbryt();
            arkivWebRessurs.meldingTilBruker.feilmelding(`${arkivWebRessurs.gettextCatalog.getString('Filen')}'${fil.name}' ${arkivWebRessurs.gettextCatalog.getString('kunne ikke lastes opp pga. manglende MIME-type.')}`);
            arkivWebRessurs.logger.info(`Filopplasting mangler MIME. Filendelse: ${fil.name.split('.')[1]}`);
        }
    }

    static opprettDokument(fil: File, mappeId: string, vedOk: (nyttDokument: l.ArkivFilnodeModell) => void, arkivWebRessurs: ArkivWebRessurs) {
        return new ArkivFilopplasting<l.ArkivFilnodeModell>(fil, mappeId, `/api/arkiv/${mappeId}/fil`, vedOk, arkivWebRessurs);
    }

    static opprettDokumentVersjon(fil: File, mappeId: string, arkivFilnodeId: string, vedOk: (nyttDokument: l.ArkivFilnodeModell) => void, arkivWebRessurs: ArkivWebRessurs) {
        return new ArkivFilopplasting<l.ArkivFilnodeModell>(fil, mappeId, `/api/arkiv/${arkivFilnodeId}/fil/versjon`, vedOk, arkivWebRessurs);
    }

    static importerArkivFraZip(zipFil: File, rotmappeId: string, vedOk: (importresultat: l.ImportresultatModell) => void, arkivWebRessurs: ArkivWebRessurs) {
        return new ArkivFilopplasting<l.ImportresultatModell>(zipFil, rotmappeId, `/api/arkiv/${rotmappeId}/importer`, vedOk, arkivWebRessurs);
    }

    startOpplasting(): ArkivFilopplasting<RETUR> {
        if (this.jobb || this.avbrutt) return;

        this.jobb = this.arkivWebRessurs.ngFileUpload.upload<RETUR>(
            <any>{
                url: this.url,
                method: 'PUT',
                data: {
                    file: this.fil,
                    info: this.arkivWebRessurs.ngFileUpload.json({
                        stoerrelse: this.fil.size,
                        type: this.mimetype,
                        filnavn: this.fil.name
                    })
                },
                //sørger for at properties i 'info' sendes med json-content-type
                //merk at vi ved å registrere vår egen formDataAppender ikke lenger
                //kan benytte ng-file-uploads resume funksjonalitet da Upload.addFieldToFormData
                //ikke lenger blir kalt (se Upload.digestConfig)
                formDataAppender: (formData: FormData, key, val) => {
                    if (key == "info")
                        formData.append(key, new Blob([val], {type: 'application/json'}));
                    else
                        formData.append(key, val, val.ngfName || val.name);
                },
            });
        this.jobb.progress(evt => {
            this.progresjon = 100 * Math.floor(evt.loaded / evt.total)
        });
        this.jobb
            .then((nyttDokument) => {
                this.arkivWebRessurs.fjernOpplasting(this);
                this.vedOk(nyttDokument.data);
                return nyttDokument;
            })
            .catch((e) => {
                if (this.avbrutt) return;
                this.arkivWebRessurs.$log.error('Feil under opplasting av arkivdokument, e: ' + angular.toJson(e)); //vi har i loggen fått meldinger om feilet opplasting uten at vi har kunnet ident årsak, logger derfor exception her
                let melding = this.arkivWebRessurs.gettextCatalog.getString('Feil under opplasting av {{filnavn}}', {filnavn: this.fil.name});
                this.arkivWebRessurs.meldingTilBruker.feilmelding(melding, Varighet.timeout, null, false);
                this.arkivWebRessurs.fjernOpplasting(this);
            });
        return this;
    }

    avbryt() {
        if (this.avbrutt) return;
        this.avbrutt = true;
        if (this.jobb) this.jobb.abort();
        this.arkivWebRessurs.fjernOpplasting(this);
    }
}
